import React, { useEffect, useId, useMemo, useState } from "react";
import Header from "./header"; // Update this path if your common Header is stored elsewhere

const L = 'https://kaart.chola.murugappa.com';
const S = 'https://adss.netaccessindia.com/authorization.do';
const fresh = 'Check with the dealer and ask for a fresh product and Serial Number.';
const FAQ_DATA = [
    ['Portal & Login', [
        ['CholaKaart is not opening. What should I do?', 'Check your internet connection.|Clear the browser cache and history.|Give the website all required permissions.|Do not use an APK or an old link.|Use the latest link: <a href="' + L + '">' + L + '</a>|If the issue continues, note the on-screen error and contact the relevant support team.'],
        ['I am unable to log in. What should I do?', 'Make sure your internet connection is stable.|Recheck the Employee/Dealer ID and Password.|If your password has expired, update your SSO password: <a href="' + S + '">' + S + '</a>|If your User ID is blocked, contact your Territory Manager.'],
        ['The dealer store is not visible. Why?', 'The dealer may not be approved for sourcing or not mapped to the correct SFE ID.|Check both. If the issue continues, contact Operations/Credit.'],
        ['The Brand, Model or Scheme is not visible. Why?', 'The dealer may not be approved by the OEM, or mapping is incomplete.|Check OEM approval for the dealer.|Check the Brand, DMS Code and State Code are correct in DEP.|Complete the required mapping before escalating.'],
        ['What does "Product Count Breached" mean?', 'The customer is not eligible for another loan because of multiple running loans, as per policy. Read the message on screen and follow the applicable policy.']
    ]],
    ['Customer Verification', [
        ['The customer is not receiving the OTP.', 'Recheck the customer\'s mobile number.|Check the customer\'s network connectivity.|Tap Resend OTP.|Ask the customer to switch Airplane Mode ON and OFF, then try again.'],
        ['PAN verification is failing.', 'Re-enter the correct PAN.|If the PAN is correct but it still fails, the PAN API may be unstable or unavailable.|If the issue continues, contact the Central Team.'],
        ['Name, Gender or Date of Birth mismatch error.', 'Name: enter exactly as per PAN.|Gender: select the correct gender.|DOB: enter exactly as per PAN.|Recheck the details before proceeding.'],
        ['What does "Outside Geo-Limit" mean?', 'The customer\'s PIN code is more than 40 km from the dealer, or the dealer\'s geo-location is not updated.|Check the customer\'s PIN code as per KYC.|Compare the customer\'s location with the dealer\'s.|If the dealer\'s geo-location is not updated, contact the Support Team.'],
        ['Email or Alternate Mobile verification is failing.', 'This is usually incorrect data entry.|Email: re-enter the correct Email ID.|Alternate Mobile: re-enter or use the correct number.'],
        ['Why was the customer\'s case rejected?', 'The required BRE norms were not met. The reason is shown on screen.|For manual underwriting, the case cannot be re-appraised.|Clearly share the rejection reason with the customer/dealer.']
    ]],
    ['Product & Scheme', [
        ['I see "No Matching Variant".', 'The selected model is not mapped or approved by the OEM. Check the latest Scheme Chart for available models/variants.'],
        ['Model Minimum/Maximum Price error.', 'The price entered is outside the permissible range. Check the price range in the latest Scheme Chart and enter the price again.']
    ]],
    ['Banking & Mandate', [
        ['The IFSC is invalid.', 'The IFSC may need to be updated in the banking master. Check the IFSC entered and follow the process to update the banking master.'],
        ['"Invalid Beneficiary Details" error.', 'Incorrect beneficiary details may have been entered. Recheck and enter the correct details, then try again.'],
        ['I am getting an NPCI or Mandate error.', 'Follow the action based on the error message shown.|If there is no response or the NPCI response is delayed, wait and retry.|Avoid repeated attempts within a short period.']
    ]],
    ['KFS & Documents', [
        ['KFS generation has failed.', 'The cause may be a network, API or OTP generation issue.|Check the network of both the customer and the user.|Retry the process.|If the issue continues, contact the Support Team.'],
        ['The KFS link has expired.', 'The customer did not complete the KFS formalities in the stipulated time.|Retry the process.|Ask the customer to complete the details within the stipulated time.']
    ]],
    ['IMEI / Serial No.', [
        ['How does IMEI/Serial Number validation work?', 'It is done through API integration with the OEM. The error message shows the reason and action required. For OEM API issues, Chola Support has limited resolution capability and may need to coordinate with the OEM.'],
        ['What should I check before retrying?', 'The IMEI/Serial Number entered is correct.|It belongs to the same make/model selected in the journey.|The product is billed to the dealer from where the loan is attempted.|The correct DMS Code/State Code (where applicable) is updated in DEP and shown on the validation page.|Read the error message carefully every time.'],
        ['Why avoid repeated failed attempts?', 'They may block the IMEI/Serial Number or the user for 3 to 24 hours.'],
        ['Serial Number already validated, serviced or linked to another dealer.', 'Do not keep trying the same Serial Number.|Check with the dealer and ask for a fresh eligible product and Serial Number.|For dealer or mapping issues, check with the Product Team where applicable.'],
        ['"You Are Not Authorized" or Server Issue.', 'This may be a network or server issue.|Check the network connection.|Wait for some time and retry the validation.|If it continues, follow the relevant support process.'],
        ['"Serial Number Does Not Exist".', 'Recheck the Serial Number, enter the correct one and retry.'],
        ['"Invalid Model".', 'The selected model is blocked by the OEM for financing. Check the latest Scheme Chart and, if required, check with the Product Team.'],
        ['"Invalid Dealer".', 'The DMS Code may be incorrect or the dealer is not mapped.|Recheck the dealer details.|Check with the Product Team for mapping or correction.'],
        ['"Unauthorized Dealer".', 'The Serial Number is billed to another location. ' + fresh],
        ['"Serial Number Belongs to RR".', 'It is billed to Regional Retail. ' + fresh],
        ['"Serial Number Already Serviced".', 'The OEM has already serviced it. ' + fresh],
        ['"Serial Number Already Punched".', 'The product with that Serial Number has already been sold. ' + fresh],
        ['"Display Serial Number".', fresh],
        ['"Unauthorized Sale".', 'The Serial Number is blocked by the OEM for financing. Do not make repeated attempts. ' + fresh]
    ]],
    ['Defeaturing & Restoration', [
        ['Do I need to manually defeature or restore a phone?', 'No. Defeaturing and its removal are done automatically through APIs. The phone restores to NORMAL once the required conditions are met.'],
        ['The phone is not getting restored. What should the customer check?', 'Ask the customer to log in to the Chola One App and check:|The outstanding amount is ₹0.|The phone is connected to the internet via Mobile Data or Wi-Fi.|The HFin app has permission to use Mobile Data/Wi-Fi.'],
        ['How do I enable Mobile Data/Wi-Fi for the HFin App?', 'Long press the HFin App → App Info → Mobile Data & Wi-Fi → Enable.'],
        ['When will the phone return to normal?', 'Once the outstanding amount is ₹0, the phone is online and the HFin App has Mobile Data/Wi-Fi access, it restores to NORMAL automatically.']
    ]]
];

const FAQ_STYLES = `
  /* The page owns its scrolling. It does not rely on window/body scroll, so a leaked body lock,
     a fixed-height parent layout, or a stuck wrapper cannot stop it from scrolling. */
  .los-faq-root{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1000;display:flex;flex-direction:column;background:#f4f7fb;overflow:hidden}
  .los-faq-root>.position-relative{flex:0 0 auto}
  .los-faq-page{flex:1 1 auto;min-height:0;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;background:#f4f7fb;color:#172b4d;font-family:Inter,ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;padding:20px 16px 40px}
  .los-faq-shell{max-width:1100px;margin:0 auto}
  .los-faq-page button,.los-faq-page input{font-family:inherit}
  .los-faq-tools{display:flex;gap:12px;align-items:center;flex-wrap:wrap;margin:0 0 14px}
  .los-faq-search-wrap{display:flex;align-items:center;gap:8px;flex:1;min-width:240px;background:#fff;border:1px solid #d7e0ee;border-radius:12px;padding:0 12px;box-shadow:0 2px 7px rgba(16,42,80,.04);color:#5d6d85}
  .los-faq-search-wrap:focus-within{border-color:#7ba7ef;box-shadow:0 0 0 3px rgba(123,167,239,.35)}
  .los-faq-search-wrap svg{flex:0 0 auto}
  .los-faq-search-wrap input{width:100%;min-width:0;border:0;outline:0;padding:13px 0;font-size:14px;background:transparent;color:#172b4d;-webkit-appearance:none;appearance:none}
  .los-faq-search-wrap input::-webkit-search-cancel-button,.los-faq-search-wrap input::-webkit-search-decoration{-webkit-appearance:none;display:none}
  .los-faq-clear{border:0;background:#edf3ff;color:#174ea6;border-radius:8px;padding:6px 10px;font-size:12px;font-weight:700;cursor:pointer;flex:0 0 auto}
  .los-faq-clear:hover{background:#dde8ff}
  .los-faq-count{font-size:12px;color:#5d6d85;font-weight:700;white-space:nowrap}
  .los-faq-categories{display:flex;gap:8px;overflow-x:auto;padding:2px 2px 12px;scrollbar-width:thin;-webkit-overflow-scrolling:touch}
  .los-faq-category{flex:0 0 auto;white-space:nowrap;border:1px solid #cbd7e8;background:#fff;color:#29476e;border-radius:999px;padding:9px 14px;font-size:12px;font-weight:700;cursor:pointer;transition:background .15s ease}
  .los-faq-category:hover{background:#f0f5ff}
  .los-faq-category[aria-pressed="true"]{background:linear-gradient(2deg, #3f5ae6 32.19%, #8541f9 84.34%);border-color:#174ea6;color:#fff}
  .los-faq-category:focus-visible,.los-faq-question:focus-visible,.los-faq-clear:focus-visible{outline:3px solid #8bb5fa;outline-offset:2px}
  .los-faq-section-title{font-size:17px;font-weight:800;color:#1d3d70;margin:20px 0 10px}
  .los-faq-card{background:#fff;border:1px solid #dfe7f2;border-radius:13px;overflow:hidden;margin-bottom:10px;box-shadow:0 2px 8px rgba(16,42,80,.035)}
  .los-faq-question{width:100%;display:flex;align-items:flex-start;gap:12px;text-align:left;border:0;background:#fff;color:#1d2f4d;padding:16px 18px;font-size:14px;line-height:1.5;font-weight:700;cursor:pointer}
  .los-faq-question:hover{background:#f8faff}
  .los-faq-qmark,.los-faq-amark{display:inline-flex;align-items:center;justify-content:center;flex:0 0 26px;width:26px;height:26px;border-radius:8px;font-size:13px;font-weight:800}
  .los-faq-qmark{background:#eaf1ff;color:#174ea6}
  .los-faq-amark{background:#e5f5ec;color:#18794e}
  .los-faq-question-text{flex:1;min-width:0;padding-top:3px;overflow-wrap:anywhere}
  .los-faq-chevron{flex:0 0 auto;margin-top:5px;color:#56708f;transition:transform .15s ease}
  .los-faq-card.open .los-faq-chevron{transform:rotate(180deg)}
  .los-faq-answer{display:flex;gap:12px;border-top:1px solid #edf1f7;padding:16px 18px 18px;background:#fbfcff;font-size:13px;line-height:1.65;color:#43546d}
  .los-faq-answer-content{flex:1;min-width:0;padding-top:2px;overflow-wrap:anywhere}
  .los-faq-answer-content p{margin:0 0 8px}.los-faq-answer-content p:last-child{margin-bottom:0}
  .los-faq-answer-content a{color:#1759b2;font-weight:700;overflow-wrap:anywhere}
  .los-faq-answer-content ul{margin:0;padding-left:19px}.los-faq-answer-content li{margin:0 0 5px}.los-faq-answer-content li:last-child{margin-bottom:0}
  .los-faq-answer-content li p{margin:0}
  .los-faq-mark{background:#ffec99;color:inherit;border-radius:2px;padding:0 1px}
  .los-faq-empty{padding:28px 18px;background:#fff;border:1px dashed #cbd7e8;border-radius:13px;text-align:center;color:#62738b;overflow-wrap:anywhere}
  .los-faq-tip{margin-top:22px;padding:14px 16px;border-radius:12px;background:#eaf1ff;color:#17417d;font-size:13px;line-height:1.55;font-weight:700}
  @media(max-width:600px){.los-faq-page{padding:14px 10px 28px}.los-faq-tools{gap:8px}.los-faq-count{width:100%}.los-faq-question{padding:14px}.los-faq-answer{padding:14px}.los-faq-category{padding:8px 12px}}
`;

const slug = (value) => value.replace(/[^a-z0-9]+/gi, "-");

function escapeRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function Highlight({ text, query }) {
    const cleanText = String(text ?? "");
    const q = query.trim();
    if (!q) return cleanText;
    const parts = cleanText.split(new RegExp(`(${escapeRegExp(q)})`, "ig"));
    return parts.map((part, index) =>
        part.toLowerCase() === q.toLowerCase()
            ? <mark className="los-faq-mark" key={index}>{part}</mark>
            : <React.Fragment key={index}>{part}</React.Fragment>
    );
}

function AnswerLine({ line, query }) {
    // FAQ_DATA stores links as HTML strings; render them as real React links instead of using innerHTML.
    const linkMatch = line.match(/<a href="(https?:\/\/[^"]+)">([^<]+)<\/a>/i);
    if (linkMatch) {
        const before = line.slice(0, linkMatch.index);
        const after = line.slice(linkMatch.index + linkMatch[0].length);
        return (
            <p>
                {before && <Highlight text={before} query={query} />}
                <a href={linkMatch[1]} target="_blank" rel="noopener noreferrer"><Highlight text={linkMatch[2]} query={query} /></a>
                {after && <Highlight text={after} query={query} />}
            </p>
        );
    }
    return <p><Highlight text={line} query={query} /></p>;
}

const SearchIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
        <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
    </svg>
);

const ChevronIcon = () => (
    <svg className="los-faq-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="m6 9 6 6 6-6" />
    </svg>
);

// Bootstrap modals/offcanvas put `overflow: hidden` on <body> and only undo it on a clean close. If the
// user navigates here mid-transition, that lock (or a late re-apply of it) leaks onto this page. This page
// has no Bootstrap modals, so it is safe to keep releasing the lock while the page is mounted.
function useReleaseScrollLock() {
    useEffect(() => {
        const { body, documentElement: html } = document;
        const release = () => {
            if (document.querySelector(".modal.show, .offcanvas.show")) return;
            const locked =
                body.classList.contains("modal-open") ||
                body.classList.contains("offcanvas-open") ||
                body.style.overflow === "hidden" ||
                body.style.paddingRight !== "" ||
                html.style.overflow === "hidden" ||
                document.querySelector(".offcanvas-backdrop, .modal-backdrop");
            if (!locked) return; // guard: touching attributes unnecessarily would re-trigger the observer
            body.classList.remove("modal-open", "offcanvas-open");
            body.style.removeProperty("overflow");
            body.style.removeProperty("padding-right");
            html.style.removeProperty("overflow");
            document.querySelectorAll(".offcanvas-backdrop, .modal-backdrop").forEach((el) => el.remove());
        };
        // A menu/offcanvas left open by the previous screen keeps `overflow: hidden` on <body> and makes
        // release() bail out below. Close it via its own dismiss button (works without the bootstrap global).
        document
            .querySelectorAll(".offcanvas.show [data-bs-dismiss='offcanvas'], .offcanvas.showing [data-bs-dismiss='offcanvas']")
            .forEach((btn) => btn.click());
        release();
        window.scrollTo(0, 0);
        const observer = new MutationObserver(release);
        const opts = { attributes: true, attributeFilter: ["style", "class"] };
        observer.observe(body, opts);
        observer.observe(html, opts);
        return () => observer.disconnect();
    }, []);
}

export default function CholaKaartLosJourneyFAQs({
    searchTerm: searchProp,
    setSearchTerm: setSearchProp,
    showSearchModal: showModalProp,
    setShowSearchModal: setShowModalProp,
}) {
    // Works controlled (state owned by Faq.jsx) or standalone.
    const [localSearch, setLocalSearch] = useState("");
    const searchTerm = searchProp ?? localSearch;
    const setSearchTermRaw = setSearchProp ?? setLocalSearch;
    const [localModal, setLocalModal] = useState(false);
    const showSearchModal = showModalProp ?? localModal;
    const setShowSearchModal = setShowModalProp ?? setLocalModal;

    const [activeCategory, setActiveCategory] = useState("All");
    // Search is global: typing from the header or the page bar searches every category.
    const setSearchTerm = (value) => {
        setSearchTermRaw(value);
        if (value.trim()) setActiveCategory("All");
    };
    const [openItems, setOpenItems] = useState({});
    const uid = useId();

    useReleaseScrollLock();

    const keyword = searchTerm.trim().toLowerCase();
    const searching = keyword.length > 0;

    const categories = useMemo(() => ["All", ...FAQ_DATA.map(([category]) => category)], []);

    const visibleGroups = useMemo(() => (
        FAQ_DATA
            .filter(([category]) => activeCategory === "All" || category === activeCategory)
            .map(([category, faqs]) => [category, faqs.filter(([question, answer]) => {
                const searchableAnswer = answer
                    .replace(/<[^<>]*>/g, " ")
                    .replace(/\|/g, " ");
                return !keyword || `${question} ${searchableAnswer}`.toLowerCase().includes(keyword);
            })])
            .filter(([, faqs]) => faqs.length > 0)
    ), [activeCategory, keyword]);

    const resultCount = visibleGroups.reduce((count, [, faqs]) => count + faqs.length, 0);

    // While searching, matching answers open automatically so the highlighted match is visible;
    // the user can still collapse any item manually.
    const isItemOpen = (key) => openItems[key] ?? searching;
    const toggleItem = (key) => setOpenItems((current) => ({ ...current, [key]: !(current[key] ?? searching) }));

    return (
        <div className="los-faq-root">
            <style>{FAQ_STYLES}</style>
            <Header
                title="Chola Kaart FAQs"
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
                showSearchModal={showSearchModal}
                setShowSearchModal={setShowSearchModal}
            />
            <div className="los-faq-page">
                <div className="los-faq-shell">
                    <div className="los-faq-tools" role="search">
                        <div className="los-faq-search-wrap">
                            <SearchIcon />
                            <input
                                type="search"
                                value={searchTerm}
                                onChange={(event) => setSearchTerm(event.target.value)}
                                placeholder="Search questions, errors, or keywords…"
                                aria-label="Search FAQ questions and answers"
                            />
                            {searchTerm && (
                                <button className="los-faq-clear" type="button" onClick={() => setSearchTerm("")}>Clear</button>
                            )}
                        </div>
                        <span className="los-faq-count" aria-live="polite">{resultCount} {resultCount === 1 ? "result" : "results"}</span>
                    </div>

                    <nav className="los-faq-categories" aria-label="FAQ categories">
                        {categories.map((category) => (
                            <button
                                key={category}
                                type="button"
                                className="los-faq-category"
                                aria-pressed={activeCategory === category}
                                onClick={() => setActiveCategory(category)}
                            >
                                {category}
                            </button>
                        ))}
                    </nav>

                    <main>
                        {visibleGroups.length === 0 ? (
                            <div className="los-faq-empty">No FAQs match <strong>“{searchTerm.trim()}”</strong>. Try another keyword or clear the search.</div>
                        ) : visibleGroups.map(([category, faqs]) => {
                            const headingId = `${uid}-heading-${slug(category)}`;
                            return (
                                <section key={category} aria-labelledby={headingId}>
                                    <h2 className="los-faq-section-title" id={headingId}>{category}</h2>
                                    {faqs.map(([question, answer]) => {
                                        const key = `${category}::${question}`;
                                        const isOpen = isItemOpen(key);
                                        const lines = answer.split("|");
                                        const panelId = `${uid}-panel-${slug(key)}`;
                                        return (
                                            <article className={`los-faq-card${isOpen ? " open" : ""}`} key={key}>
                                                <button
                                                    className="los-faq-question"
                                                    type="button"
                                                    aria-expanded={isOpen}
                                                    aria-controls={panelId}
                                                    onClick={() => toggleItem(key)}
                                                >
                                                    <span className="los-faq-qmark" aria-hidden="true">Q</span>
                                                    <span className="los-faq-question-text"><Highlight text={question} query={searchTerm} /></span>
                                                    <ChevronIcon />
                                                </button>
                                                {isOpen && (
                                                    <div className="los-faq-answer" id={panelId}>
                                                        <span className="los-faq-amark" aria-hidden="true">A</span>
                                                        <div className="los-faq-answer-content">
                                                            {lines.length > 1 ? (
                                                                <ul>{lines.map((line, index) => <li key={index}><AnswerLine line={line} query={searchTerm} /></li>)}</ul>
                                                            ) : <AnswerLine line={lines[0]} query={searchTerm} />}
                                                        </div>
                                                    </div>
                                                )}
                                            </article>
                                        );
                                    })}
                                </section>
                            );
                        })}
                    </main>

                    <div className="los-faq-tip">Check → Recheck → Retry → Read the error → Escalate to the right support team</div>
                </div>
            </div>
        </div>
    );
}
